import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { SelectableLab } from '../carrier/selectable-lab';
import { SelectItem } from 'primeng/api';
import { Controls } from '../masterdata/models/controls'
import { Chemical } from '../masterdata/models/chemical';
import { WorkFlow } from '../masterdata/models/workFlow';
import * as omit from 'lodash/omit';
import * as cloneDeep from 'lodash/cloneDeep';
import { BBResponseContainer } from '../carrier/response-container';

@Component({
  selector: 'app-chemical',
  templateUrl: './chemical.component.html',
  styleUrls: ['./chemical.component.css']
})
export class ChemicalComponent implements OnInit {
  @Input() masterLists: Array<Chemical>;

  _labOptions: Array<LabMDM>;

  @Input() chemicalHeaders: Array<Chemical>;

  @Input() title: string;

  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }

  @Input() checkSelectedLab: SelectableLab;

  errorHandler: ErrorHandler = new ErrorHandler();

  chemicalGroupsOptions: Array<any>;

  processStepOptions: Array<any>;

  workFlowOptions: Array<any> = [];
  workFlowData: WorkFlow[] = [];
  
  controlSchemaOptions: SelectItem[] = [];

  selectedWorkFlow: any;
  selectedChemical: any;

  chemical: Chemical;

  showChemicalDialogue: boolean;

  selectableLab: SelectableLab;

  selectedLabId: string;
  selectedProcess: string;

  controls: Controls[] = [];

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showErrorOnSave = this.showErrorOnSave.bind(this);
     this.showErrorOnUpdate = this.showErrorOnUpdate.bind(this);
  }

  ngOnInit() {
    this.masterLists = [];
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
    this.selectedProcess = localStorage.getItem('process');

    if(this.selectedProcess==='NGS'){
      this.processStepOptions = [
        { name: 'Sample QC', value: 'SAMPLE_QC' },
        { name: 'Normalization', value: 'NORMALIZATION' },
        { name: 'Tagmentation', value: 'TAGMENTATION' },
        { name: 'Purification', value: 'PURIFICATION' },
        { name: 'Ligation', value: 'INDEX_LIGATION' },
        { name: 'Clean Up', value: 'CLEAN_UP' },
        { name: 'Library QC', value: 'LIBRARY_QC' }
      ]
    }else{
      this.processStepOptions = [
        { name: 'Resuspend DNA', value: 'RESUSPEND_DNA' },
        { name: 'Recombine DNA', value: 'RECOMBINE_DNA' },
        { name: 'Precipitate DNA', value: 'PRECIPITATE_DNA' },
        { name: 'Denaturate DNA', value: 'DENATURATE_DNA' },
        { name: 'Amplify PGX', value: 'AMPLIFY_PGX' },
        { name: 'Amplify WGA', value: 'AMPLIFY_WGA' },
        { name: 'Fragment DNA', value: 'FRAGMENT_DNA' },
        { name: 'Hybridization', value: 'HYBRIDIZATION' },
        { name: 'Staining', value: 'STAINING'}
      ];
    }

    this.getAllActiveWorkFlowList();
  }

  handleAddNewChemical() {
    this.chemical = { active: true };
    this.chemical.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === this.selectedLabId);;
    this.showChemicalDialogue = true;
    this.controlSchemaOptions = [];
    this.getControls();

  }

  getAllActiveWorkFlowList() {
    let configName = this.selectedProcess=='NGS' ? 'workflowngs' : 'workflow';
    this._masterDataService.getConfigList(this.selectableLab.lab._id, configName, 0, 100, true).subscribe(results => {
      if (results && results.data) {
        this.workFlowData = results.data;
        this.workFlowData.forEach(e => {
          this.workFlowOptions.push({ name: e.workFlowName, value: e.workFlowName });
        });
      }
    },
      (error: any) => {
        this.showError(error);
      });

  }

  showErrorOnSave() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to create Chemical. Try with other chemical, may be it is duplicate"
    });
  }
  showErrorOnUpdate() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to update chemical configurations.Try with otherchemical name, may be it is duplicate"
    });
  }

  showError(error: Error){
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to get list of workflows."
    })
  }

  private getControls() {
    this.controlSchemaOptions=[];
    this._masterDataService.getControls(this.selectedLabId, "controls").subscribe(
      results => {
        if (!results) {
          return;
        }
        this.controls = results.data;
        this.controls.forEach(control => {
          this.controlSchemaOptions.push({ label: control.controlConfigurationName, value: control.controlConfigurationName });
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  handleSaveOrUpdate(){
    const { _id } = this.chemical;
    if (this.isValid()) {
      const chemicalItem: Chemical = Object.assign({}, this.chemical, { workFlow: ((this.chemical.workFlow || {}) as any).value },
      { processStep: ((this.chemical.processStep || {}) as any).value });
      chemicalItem.process = this.selectedProcess;
      if (_id) {
        this._masterDataService.updateChemical(chemicalItem, this.selectedLabId, _id).subscribe((response: BBResponseContainer ) => {
          this.showChemicalDialogue = false;
          const selectedChemicalIndex: number = this.masterLists.findIndex((chemicalData: Chemical) => chemicalData._id === _id);
          this.masterLists[selectedChemicalIndex] = response.data;
        }, this.showErrorOnUpdate);
      } else {
        this._masterDataService.addChemical(chemicalItem, this.selectedLabId, 'chemical').subscribe((response: BBResponseContainer) => {
          this.showChemicalDialogue = false;
          const { data } = response;
          if(this.masterLists == undefined)
            this.masterLists = [data]
          else
            this.masterLists.push(data);
        }, this.showErrorOnSave);
      }
    }
  }

  isValid() {
    const { chemicalName = '', workFlow, lab, processStep, description } = this.chemical;
    this.chemical = omit(this.chemical, ['id']);
    if (!chemicalName.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Chemical name',
        detail: 'Chemical name cannot be empty'
      });
      (this.chemical as any).nameError = true;
      return false;
    } else if (!lab) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Lab',
        detail: 'Please select the Lab'
      });
      (this.chemical as any).labError = true;
      return false;
    } else if (!workFlow) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'WorkFlow',
        detail: 'Work flow cannot be empty'
      });
      (this.chemical as any).nameError = true;
      return false;
    } else if (!processStep) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Process Step',
        detail: 'Process Step  cannot be empty'
      });
      (this.chemical as any).nameError = true;
      return false;
    } else if (!description) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Description',
        detail: 'Description cannot be empty'
      });
      (this.chemical as any).nameError = true;
      return false;
    }
    return true;
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    const { workFlow = '' } = data;
    const { processStep = '' } = data;
    const { description = '' } = data;
    this.chemical = cloneDeep(data);
    this.chemical.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.chemical.workFlow = this.workFlowOptions.find((fileFormatItem: any) => fileFormatItem.name === workFlow);
    this.chemical.processStep = this.processStepOptions.find((fileFormatItem: any) => fileFormatItem.value === processStep);
    this.chemical.description = description;
    this.showChemicalDialogue = true;
  }

}
